import React from 'react'
import { useIntl } from 'react-intl'
import ClickableLink from 'components/Common/Clickable/ClickableLink'
import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import Image from 'components/Common/Image'

function AppLinks() {
  const intl = useIntl()

  const title = intl.formatMessage({
    id: 'Ft8_YpZ9J5Qlr88-zhZr',
    defaultMessage: 'Download Our Free Mobile App',
    description: 'Heading title for mobile app download section in footer',
  })

  const iphoneAppAlt = intl.formatMessage({
    id: 'h_VHBfH6OKevSb_aV56n',
    defaultMessage: 'Download the iPhone app',
    description: 'Accessibility alt text for iPhone app download button',
  })

  const androidAppAlt = intl.formatMessage({
    id: '3-znbVgZsmwp0GSHIoe1',
    defaultMessage: 'Download the Android app',
    description: 'Accessibility alt text for Android app download button',
  })

  return (
    <VerticalSpacer gap={16}>
      <BodyText variant="large" as="h4" weight="bold" align="center" tabletAlign="start">
        {title}
      </BodyText>
      <Group direction="horizontal" horizontalAlign="center" tabletHorizontalAlign="start" gap={8}>
        <ClickableLink href="https://app.luxuryescapes.com/3WHB/1aab092" target="_blank" rel="noopener">
          <Image id="App_Store_suxzv1" alt={iphoneAppAlt} width={158} />
        </ClickableLink>
        <ClickableLink href="https://app.luxuryescapes.com/3WHB/feb04c69" target="_blank" rel="noopener">
          <Image id="Google_Play_o1xn2t" alt={androidAppAlt} width={158} />
        </ClickableLink>
      </Group>
    </VerticalSpacer>
  )
}

export default AppLinks
